export function objPropTrim(obj) {
  if (obj) {
    if (Array.isArray(obj)) {
      obj = obj.map(item => objPropTrim(item))
    } else {
      if (typeof obj === 'string') {
        return obj.trim()
      } else if (typeof obj === 'object') {
        Object.keys(obj).forEach(key => {
          obj[key] = objPropTrim(obj[key])
        })
      }
    }
  }
  return obj
}

export function getUrlParam(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const r = window.location.search.substr(1).match(reg)
  if (r !== null) {
    return decodeURI(r[2])
  } else {
    return null
  }
}

export function callHook(vm, context, hook, hookType) {
  if (!context) {
    console.warn('context is undefined')
    return
  }
  let result
  const handler = context[hook]
  if (handler) {
    result = handler.call(vm, hookType)
  } else {
    console.warn(`hook【${hook}】未定义`)
  }
  return result
}
